import * as React from "react";

import {AGENT_LEVEL, BRANCH_LEVEL} from "../../xpresso/src/routes/common/logic/user-level";
import ReactGA                     from "../libs/ga/xd-react-ga";
import {cs}                        from "../react/chain-services";
import {consumeContext}            from "../react/context";
import {Invoke}                    from "../react/invoke";

const GA4_ = {
    trackingId: "G-RK6JDWQRD2",
    trackingId2: "AW-1060002594",
    environment: (
        window.location.hostname == "www.xpressdocs.com" ? (
            "production"
        ) : window.location.hostname.includes("stage") ? (
            "stage"
        ) : (
            "dev"
        )
    ),
};

export const loadGA4 = ({next:rootNext, app}) => cs(
    consumeContext("session"),
    consumeContext("company"),
    consumeContext("userLevels"),
    ({userLevels}, next) => userLevels ? next() : rootNext(),
    ["userProperties", ({session, company, userLevels}, next) => {
        const idUser = String(userLevels.idUser);
        const userLevel = String(userLevels.userLevel);
        if(userLevels.userLevel === AGENT_LEVEL)
        {
            const idAgent = session?.data?.agent?.idAgent;
            const idBranch = session?.data?.branch?.idBranch;
            const idCompany = company?.idCompany;
            if(idCompany && idUser && idAgent && idBranch) {
                return next({
                    userId: idUser,
                    userLevel: userLevel,
                    idCompany: idCompany,
                    idBranch: idBranch,
                    idAgent: idAgent,
                })
            }
            else
            {
                // Something here?
                return null;
            }
        } else if(userLevels.userLevel === BRANCH_LEVEL) {
            const idBranch = session?.data?.branch?.idBranch;
            const idCompany = company?.idCompany;
            if(idCompany && idUser && idBranch)
            {
                return next({
                    userId: idUser,
                    userLevel: userLevel,
                    idCompany: idCompany,
                    idBranch: idBranch,
                    idAgent: '',
                })
            }
        } else {
            const idCompany = company?.idCompany;
            if(idCompany && idUser)
            {
                return next({
                    userId: idUser,
                    userLevel: userLevel,
                    idCompany: idCompany,
                    idBranch: '',
                    idAgent: '',
                })
            }
        }
    }],
    ({userProperties}) => (
        Invoke({
            action: () => {
                ReactGA.initialize([
                    {
                        trackingId: GA4_.trackingId,
                        gaOptions: {
                            environment: GA4_.environment,
                            appName: app,
                        },
                    },
                    {
                        trackingId: GA4_.trackingId2,
                        gaOptions: {
                            environment: GA4_.environment,
                            appName: app,
                        },
                    },
                ]);
                ReactGA.gtag("set", "user_properties", userProperties);
                //send user properties to Hotjar
                if(typeof(window.hj) === "function")
                {
                    userProperties.appName = app;
                    window.hj("identify", userProperties.userId, userProperties);
                    //send Hotjar id to GA4
                    const feedbackContainer = document.getElementById('_hj_feedback_container');
                    if(feedbackContainer){
                        const widgetButtons = feedbackContainer.querySelectorAll('button[class*="Widget"]');
                        widgetButtons.forEach(function(button) {
                            button.addEventListener('click', function() {
                                const hotjarId = window.hj.bridge.getSessionUserId(!0).split("-").shift();
                                ReactGA.gtag('event', 'feedback', {
                                    method: 'Hotjar',
                                    hotjarId: hotjarId,
                                });
                            });
                        })
                    }
                }
            },
            next: rootNext,
        })
    ),
);
